import { useState, useEffect } from "react";
import { getPassengers } from "../../utils/api/getPassengers.js";
import { removePassenger } from "../../utils/api/removePassenger.js";
import { CreatePassengerForm } from "./CreatePassengerForm.jsx";
import { EditPassengerForm } from "./EditPassengerForm.jsx";

export function ProfilePage6(user) {

  const [passengers, setPassengers] = useState([])
  const [showCreateForm, setShowCreateForm] = useState(false)
  const [showEditForm, setShowEditForm] = useState(false)
  const [passengerId, setPassengerId] = useState(false)

  useEffect(() => {
    // cargar datos de usuario
    loadPassengers();
  }, []);

  const handleRemovePassenger = (passengerId) => {
  
      return async () => {
        const response = await removePassenger(user, passengerId);
        if(response){
          loadPassengers();
        }
      }
  }

  const handleEditPassenger = (passengerId) => {
    console.log('Edit passenger', passengerId
    )
    setPassengerId(passengerId)
    setShowCreateForm(false)
    setShowEditForm(true)
  }
 
  const loadPassengers = async () => {
    const loadedPassengers = await getPassengers(user);

    setPassengers(loadedPassengers.data)
  }
  return (
    <>

      <div className="m-layMiCuenta__body">
        <div className="bx">
          <header>
            <br/>
            <span className="ht-body-bold uppercase" >Pasajeros</span><br/>
            <span className="ht-body-regular">Añade o edita pasajeros</span>
          </header>

          <div className="m-formPasajeros">
            <div className="row-pasajeros head">
              <div className="row-pasajeros__cabecera">
                <div><span className="ht-small-bold uppercase">Nombre</span></div>
                <div><span className="ht-small-bold uppercase">DNI</span></div>
              </div>
            </div>

            <div className="row-pasajeros">
              <div className="row-pasajeros">
                {passengers.map((passenger) => (
                  <div className="row-pasajeros__cabecera">
                    <div><span className="ht-small-regular">{passenger.name}</span></div>
                    <div><span className="ht-small-regular">{passenger.doc_number}</span></div>
                    <div> 
                      <a href="#"><button onClick={()=> handleEditPassenger(passenger.id)} className="js-btnEdit btnOrange-square-max-outline a-iconButton icon-pen" data-pasajero="0"></button></a>
                      <a href="#"><button onClick={()=>  {if(window.confirm('¿Eliminar pasajero?')){ handleRemovePassenger(passenger.id)}}} class="btnOrange-square-max-outline a-iconButton icon-trash"></button></a>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="separator"></div>
            <button className="btnOrange-l" onClick={() => setShowCreateForm(true)}>Crear Pasajero</button>
          </div>    
          
          {showCreateForm  && (<CreatePassengerForm user={user.user}/>)}     
          {showEditForm  && (<EditPassengerForm user={user.user} passengerId={passengerId}/>)}     
        </div>
      </div>
    </>
  )
}